export default __webpack_public_path__ + "static/media/CD__0006_0001.2d23f76e.png";